import axios from "axios";

const baseURL = "/api/cdk/gateway/v1";

const URL = {
  list: `${baseURL}/list`
};

const HEADERS = {
  "Content-Type": "application/json"
};

const GatewaysService = {
  getGateways: async () => {
    const response = await axios.get(`${URL.list}`, { headers: HEADERS });
    return response.data;
  },
  getGateway: async () => {
    const response = await axios.get(`${baseURL}/`, { headers: HEADERS });
    return response.data;
  },
  updateGateway: async id => {
    const response = await axios.put(
      `${baseURL}/`,
      { id },
      {
        headers: HEADERS
      }
    );
    return response.data;
  }
};

export default GatewaysService;
